export enum NoteTypes {
  ClaimsOnly = 'Claims Only',
  XpoLtl = 'XPO LTL',
  External = 'External',
}
